export default __webpack_public_path__ + "static/media/1973.41df4cf2.png";